import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import format from 'date-fns/format';

import { Table, Column, Pager, StringValue, DateValue, BooleanValue, Button, Loader } from '@smartplatform/ui';
import { groups, LAW, DECREE, LAW_PASSPORT, DECREE_PASSPORT } from './groups';
import { Tabs, Tab } from '../../components/route-tabs';
import store from '../../store';

const PER_PAGE = 20;

@observer
export default class List extends React.Component {
	@observable isLoading = true;
	@observable group = LAW;
	@observable records = [];
	@observable page = 1;
	@observable isSyncing = false;

	constructor(props) {
		super(props);
		this.group = props.group || LAW;
		this.init();
	}

	@action init = async () => {
		this.isLoading = true;
		this.records = await store.model.Document.find({
			where: {
				and: [{ docGroup: this.group }, { name: { neq: null } }],
			},
			order: 'date desc',
			limit: PER_PAGE,
			skip: (this.page - 1) * PER_PAGE,
		});
		this.isLoading = false;
	};

	trimmedName = record => {
		let name = record.name
			.replace(/«/g, '"')
			.replace(/»/g, '"')
			.trim();
		if (name.substr(0, 1) === '"') {
			return name.substr(1);
			/*
			const count = (name.match(/"/g) || []).length;
			console.log('-', count, record.id, name);
			if (count % 2 === 0) {
				return name.replace(/^"(.+)"$/,'$1');
			}
			else {
				return name.substr(1);
			}
*/
		}
		return name;
	};

	@action onPageChange = page => {
		this.page = page;
		this.init();
	};

	onIsnClick = document => {
		navigator.clipboard.writeText(document.id).then(
			function() {
				console.log('copied to clipboard', document.id);
			},
			err => {
				console.error('could not copy text', err);
			}
		);
	};

	docGroup = document => groups[document.docGroup];

	onSync = async () => {
		if (this.isSyncing) return;
		this.isSyncing = true;
		try {
			await store.model.Document.SYNC();
			await this.init();
		} catch (err) {
			console.error('SYNC error:', err);
		} finally {
			this.isSyncing = false;
		}
	};

	render() {
		if (this.isLoading && this.records.length === 0) return '...';

		let typePath = 'laws';
		if (this.group === DECREE) {
			typePath = 'decrees';
		} else if (this.group === LAW_PASSPORT) {
			typePath = 'law-projects';
		} else if (this.group === DECREE_PASSPORT) {
			typePath = 'decree-projects';
		}

		return (
			<div className={'laws-list' + (this.isLoading ? ' is-loading' : '')}>
				<Pager totalCount={this.records.totalCount} itemsPerPage={PER_PAGE} current={this.page} onChange={this.onPageChange} />
				<div className="documents-sync-toolbar" style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 10 }}>
					<Button onClick={this.onSync} disabled={this.isSyncing}>
						Синхронизация
						{this.isSyncing && <Loader size={14} style={{ marginLeft: 8, display: 'inline-block', verticalAlign: 'middle' }} />}
					</Button>
				</div>
				<Table records={this.records} path={`admin/documents/${typePath}`} className="multiline">
					{/*<Column width={140} property="docGroup" computed={this.docGroup} label="Тип" />*/}
					<Column width={100} property="freeNum" label="№" />
					<Column property="name" computed={this.trimmedName} label="Наименование" />
					<Column width={70} className="date" property="date" label="Дата">
						<DateValue format="DD.MM.YYYY" />
					</Column>
					<Column width={100} className="isn" title="Скопировать ISN" property="id" label="ISN" onClick={this.onIsnClick}>
						<StringValue />
					</Column>
					<Column width={100} className="hidden-npa" property="hiddenNpa" label="Скрыть в НПА">
						{record => (record.hiddenNpa ? <BooleanValue value={record.hiddenNpa} /> : null)}
					</Column>
				</Table>
			</div>
		);
	}
}
